<template>
	<div class="dashboard">
		<app-header/>

		<div class="container">
			<div class="row">
				
				<div class="col-sm-6">
					<div class="box-dashboard">
						<div class="bd-header">
							Entradas ultimo dia
						</div>

						<div class="bd-body expo">
							<h2>${{money(user.incomign)}}</h2>
							<p>Dinero en recaudos</p>
						</div>
					</div>
				</div>

				

				<div class="col-sm-6">
					<div class="box-dashboard">
						<div class="bd-header">
							Compras ultimo dia
						</div>

						<div class="bd-body expo">
							<h2>${{money(user.lastDay)}}</h2>
							<p>Dinero en compras</p>
						</div>
					</div>
				</div>

				

			</div>



		</div>
		
		<app-footer/>


		<b-modal id="bankModal" hide-footer title="Estadisticas del banco">
			<h2>Recaudos:</h2>
			<h1>${{money(1560000)}}</h1>
		</b-modal>

	</div>
</template>


<script>
import { mapGetters } from "vuex";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  components: {
    AppHeader,
    AppFooter
  },

  methods: {},

  computed: {
    ...mapGetters(["user"])
  }
};
</script>


<style lang="scss">
</style>
